/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const FilePDF = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g id="document--pdf" transform="translate(0.367)">
      <path
        id="Tracé_6206"
        data-name="Tracé 6206"
        d="M28.067,17.356V16H24v6.779h1.356V20.067h2.034V18.711H25.356V17.356Z"
        transform="translate(-7.731 -5.154)"
        fill="#cc2f41"
      />
      <path
        id="Tracé_6207"
        data-name="Tracé 6207"
        d="M17.711,22.779H15V16h2.711a2.036,2.036,0,0,1,2.034,2.034v2.711a2.036,2.036,0,0,1-2.034,2.034Zm-1.356-1.356h1.356a.679.679,0,0,0,.678-.678V18.034a.679.679,0,0,0-.678-.678H16.356Z"
        transform="translate(-4.832 -5.154)"
        fill="#cc2f41"
      />
      <path
        id="Tracé_6208"
        data-name="Tracé 6208"
        d="M9.389,16H6v6.779H7.356V20.745H9.389a1.358,1.358,0,0,0,1.356-1.356V17.356A1.357,1.357,0,0,0,9.389,16ZM7.356,19.389V17.356H9.389v2.034Z"
        transform="translate(-1.933 -5.154)"
        fill="#cc2f41"
      />
      <path
        id="Tracé_6209"
        data-name="Tracé 6209"
        d="M15.557,10.134V7.423a.616.616,0,0,0-.2-.474L10.609,2.2a.616.616,0,0,0-.475-.2H3.356A1.36,1.36,0,0,0,2,3.356V19.624A1.356,1.356,0,0,0,3.356,20.98H14.2V19.624H3.356V3.356H8.779V7.423a1.36,1.36,0,0,0,1.356,1.356H14.2v1.356ZM10.134,7.423v-3.8l3.8,3.8Z"
        transform="translate(-0.644 -0.644)"
        fill="#cc2f41"
      />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        width="22"
        height="22"
        transform="translate(-0.367)"
        fill="none"
      />
    </g>
  </svg>
);

export { FilePDF };
